import { createAsyncThunk } from '@reduxjs/toolkit';
import commonService from '../../../api/services/common';

export const getAllVendorFaQ = createAsyncThunk('common/get-all-vendor-faq', async ({ page }) => {
  return await commonService.getAllVendorFaQ(page);
});

export const getVendorFaQForUser = createAsyncThunk('common/get-vendor-faq-for-user', async id => {
  return await commonService.getVendorFaQForUser(id);
});

export const createVendorFaQ = createAsyncThunk('common/create-vendor-faq', async requestData => {
  return await commonService.createVendorFaQ(requestData);
});

export const updateVendorFaQ = createAsyncThunk('common/update-vendor-faq', async requestData => {
  return await commonService.updateVendorFaQ(requestData);
});

export const deleteVendorFaQ = createAsyncThunk('common/delete-vendor-faq', async id => {
  return await commonService.deleteVendorFaQ(id);
});
